import React from 'react';
import { ImageDisplay } from '@edusense/shared-ui-kit';
import { LinkPreviewCard, LinkPreviewImage, LinkPreviewContent, LinkPreviewSite, LinkPreviewTitle, LinkPreviewDescription, LinkPreviewUrl } from './styles';
/**
 * 링크 프리뷰 렌더러 컴포넌트
 */ var LinkPreviewRenderer = function(param) {
    var linkPreviewData = param.linkPreviewData;
    if (!linkPreviewData || !linkPreviewData.url) return null;
    return /*#__PURE__*/ React.createElement(LinkPreviewCard, {
        href: linkPreviewData.url,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: function(e) {
            return e.stopPropagation();
        }
    }, linkPreviewData.imageUrl && /*#__PURE__*/ React.createElement(LinkPreviewImage, null, /*#__PURE__*/ React.createElement(ImageDisplay, {
        src: linkPreviewData.imageUrl,
        alt: linkPreviewData.title || "링크 미리보기",
        className: "w-full h-full object-cover"
    })), /*#__PURE__*/ React.createElement(LinkPreviewContent, null, linkPreviewData.siteName && /*#__PURE__*/ React.createElement(LinkPreviewSite, null, linkPreviewData.siteName), linkPreviewData.title && /*#__PURE__*/ React.createElement(LinkPreviewTitle, null, linkPreviewData.title), linkPreviewData.description && /*#__PURE__*/ React.createElement(LinkPreviewDescription, null, linkPreviewData.description), /*#__PURE__*/ React.createElement(LinkPreviewUrl, null, linkPreviewData.url)));
};
export default LinkPreviewRenderer;
